<template>
    <span class="order-money">
        <span>{{ moneyFenArr[0] }}</span>
        <span v-if="moneyFenArr[1]" class="money-fen">.{{ moneyFenArr[1] }}</span>
    </span>
</template>
<script>

export default {
    name: 'order-money-font',
    props: {
        money: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        moneyFenArr() {
            return this.money ? String(this.money).split('.') : [this.money];
        },
    },
};
</script>
<style lang="less" scoped>
.order-money {
    font-family: DINAlternate, DINAlternate-Bold;
    font-size: 0.18rem;
    font-weight: 700;
    .money-fen {
        font-size: 0.13rem;
    }
}
</style>
